import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  template: `
    <div class="bg-grid"></div>
    <div class="bg-orb bg-orb-right"></div>
    <div class="bg-wave bg-wave-a"></div>
    <div class="bg-wave bg-wave-b"></div>
    <router-outlet />
  `,
  imports: [RouterOutlet],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {}
